import { AxiosHttpGet, AxiosHttpPost } from 'axios-http';
import { SPARE_PARTS } from 'resources/links';

export function getOrderById(orderId: number) {
    return AxiosHttpGet({ url: SPARE_PARTS.getById, data: { orderId } });
}
